<template>
    <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-warning shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Upcoming Events</h1>
                                <h2 class="display-4 text-white">Page Coming Soon</h2>
                                <p class="lead  text-white">For now, follow us on our social media to stay in the loop!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
</template>
<script>
export default {};
</script>
<style>
</style>
